const aws_exports = {
  aws_project_region: 'us-west-2',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_2WKRlyZUj',
  aws_user_pools_web_client_id: '1k7fkhvkqg9mim4asacq1eo9dn',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_graphqlEndpoint: 'https://dexyix6h2nh43basld25qfrveu.appsync-api.us-west-2.amazonaws.com/graphql',
}
export default aws_exports;

